import { storyCards } from "@/mocks/homeData";

export default function StoryStream() {
  const [lead, ...rest] = storyCards;

  return (
    <section id="today" className="border-y border-background-200 bg-background-100/60">
      <div className="mx-auto max-w-[1200px] px-4 py-14 md:px-6 md:py-16">
        <div className="flex items-end justify-between">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                <i className="ri-newspaper-line text-lg"></i>
              </span>
              <h3 className="font-heading text-2xl font-extrabold tracking-tight text-foreground-950 md:text-3xl">
                今日瓜榜
              </h3>
            </div>
            <p className="mt-3 text-sm text-foreground-500 md:text-base">
              把正在爆的话题讲成可以一口气读完的瓜，别错过任何一个名场面。
            </p>
          </div>
          <a
            href="#rank"
            className="hidden items-center gap-1.5 rounded-full px-4 py-2 text-sm font-medium text-foreground-600 hover:text-foreground-900 sm:inline-flex"
          >
            回到实时榜单
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        {/* lead story */}
        <a
          href="#download"
          className="group mt-8 block overflow-hidden rounded-2xl border border-background-200 bg-background-50"
        >
          <div className="grid lg:grid-cols-2">
            <div className="relative h-60 overflow-hidden md:h-72 lg:h-auto">
              <img
                src={lead.image}
                alt={lead.title}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-4 top-4 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
                今日头条瓜
              </span>
            </div>
            <div className="flex flex-col justify-center p-6 md:p-9">
              <span className="text-xs font-medium text-primary-600">{lead.tag}</span>
              <h4 className="mt-3 font-heading text-xl font-extrabold leading-snug text-foreground-950 md:text-2xl">
                {lead.title}
              </h4>
              <p className="mt-3 text-sm leading-6 text-foreground-600 md:text-base">{lead.summary}</p>
              <div className="mt-5 flex items-center gap-3">
                <span className="rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-900">
                  热力 {lead.heat}
                </span>
                <span className="text-xs text-foreground-400">26.4w 人已吃</span>
              </div>
            </div>
          </div>
        </a>

        {/* grid cards */}
        <div className="mt-6 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {rest.map((card, i) => (
            <a
              key={card.id}
              href="#download"
              className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-colors hover:border-primary-200"
            >
              <div className={`relative overflow-hidden ${i === 0 ? "h-60 md:h-64" : "h-56"}`}>
                <img
                  src={card.image}
                  alt={card.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-[11px] font-medium text-foreground-700 backdrop-blur">
                  {card.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h4 className="font-heading text-base font-bold leading-snug text-foreground-950">
                  {card.title}
                </h4>
                <p className="mt-2 line-clamp-2 flex-1 text-sm leading-6 text-foreground-500">
                  {card.summary}
                </p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                  <span className="text-xs text-foreground-400">{card.id % 2 ? "追更中" : "热度爬升"}</span>
                  <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-primary-600">
                    展开吃
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}